import { Component, input } from '@angular/core';
import { IGeneralAlerts } from '../store/alerts/state';

@Component({
    selector: 'bmt-alerts',
    templateUrl: './bmt-alerts.component.html',
    styleUrls: ['./bmt-alerts.component.scss'],
    standalone: false
})
export class BMTAlertsComponent {
  page = 'create';
  readonly bmtAlerts = input<IGeneralAlerts[]>([]);
  readonly bmtAlertErrors = input('');
}
